<template>
    <Modal 
      :id="'cmp_bookings_booking_add_artist'"
      @cancelled="onCancelClick"  
    >
      <template slot="header">
        
      </template>
      <template slot="body">
        <div class="form-group">
        <div
          class="dt-input-box--container"
          style="border-radius: 5px;border:1px solid var(--sprt-5); padding:8px;"
        >
          <label class="input-box box">
            {{$t('file_name')}}
            <input
              type="file"
              id="file"
              ref="file"
              v-on:change="handleFileUpload()"
            />
          </label>
        </div>
      </div>
      </template>
      <template slot="options">
          <button class="dt-button s7" @click="onCancelClick" >{{$t('cancel')}}</button>
          <button class="dt-button s7 v1" @click="onUploadClick" >UPLOAD</button>
      </template>
    </Modal>
  </template>
  
  <script>
  import Modal from '../../../../dt-plugins/modal/modal';

  import ModalContainer from "@dtplugins/modal/modal-container";
  import {
    ConfirmationService,
    createConfirmResult,
  } from "../../../../dt-plugins/confirmation/confirmation.service";
  export default {
    components: {     
      Modal,
      ModalContainer,   
      //AdvanceSearch,
     
    },
    mounted:async  function () {
    },
    data: function () {
      return {
        file: {}
      };
    },
    mixins: [
      
    ],
  
    computed: {
  
      supplier_order_id:function(){
        return this.$route.query.supplier_order_id;
      }
    
    
      
    },
    methods: { 
      handleFileUpload() {
        this.file = this.$refs.file.files[0];
        console.log(this.file,"file:::::::::")
      },
      onCancelClick: function() {
        this.$emit("cancelled", true);
      },
      onUploadClick:async function(){
          this.$emit('import_excel',{ file:this.file ,supplier_order_id:this.supplier_order_id });
      }
      
    }

  };
  </script>